import { RegionShared } from "@1games-ru/region-shared";
import { merge } from "lodash";
import { create } from "zustand";

type SetHudStateRequest = typeof RegionShared.Cef.Requests.SetHudStateRequest;

export interface HudDataState {
  isShow: boolean;
  isMapExpanded: boolean;
  hideSilentSpeakers: boolean;
  showTipLabel: boolean;
  hud: Partial<SetHudStateRequest>;
}

export interface HudActions {
  setIsShow: (flag: boolean) => void;
  setHud: (payload: Partial<SetHudStateRequest>) => void;
  setIsMapExpanded: (v: boolean) => void;
  setHideSilentSpeakers: (v: boolean) => void;
  setShowTipLabel: (v: boolean) => void;
  reset: () => void;
}

export type HudStore = HudDataState & HudActions;

const initialState: HudDataState = {
  isShow: false,
  isMapExpanded: false,
  hideSilentSpeakers: false,
  showTipLabel: true,
  hud: {},
};

export const useHudStore = create<HudStore>((set) => ({
  ...initialState,
  setIsShow: (flag) => set(() => ({ isShow: flag })),
  setHud: (payload) =>
    set((state) => ({
      hud: merge({}, state.hud, payload),
    })),

  setIsMapExpanded: (v) => set({ isMapExpanded: v }),
  setHideSilentSpeakers: (v) => set({ hideSilentSpeakers: v }),
  setShowTipLabel: (v) => set({ showTipLabel: v }),

  reset: () => set({ ...initialState }),
}));

export const isShowSelector = (s: HudStore) => s.isShow;
export const wheatherSelector = (s: HudStore) => s.hud?.weather;
export const locationSelector = (s: HudStore) => s.hud?.location;
export const serverInfoSelector = (s: HudStore) => s.hud?.serverInfo;
export const characterSelector = (s: HudStore) => s.hud?.character;

export const showTipLabelSelector = (s: HudStore) => s.showTipLabel;
export const hideSilentSpeakersSelector = (s: HudStore) => s.hideSilentSpeakers;

export const makeSpeakersSelector = (s: HudStore): NonNullable<SetHudStateRequest["speakers"]> => {
  const speakers = s.hud?.speakers ?? [];
  const list = speakers.filter((i) => i.isSpeaking);
  return list.slice(0, 4);
};
